import { IDepartment, IDepartmentData } from '../department.types';
import { Department } from '../department';

export const mockDepartmentsData = (): IDepartmentData[] => [
  {
    id: 1,
    code: '304',
    name: 'IT'
  },
  {
    id: 2,
    code: '201',
    name: 'Engineering',
    production: true
  }
];

export const mockDepartments = (
  data: IDepartmentData[] = mockDepartmentsData()
): IDepartment[] => data.map(item => new Department(item));
